import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {LicenseService, SalesForceData} from '@q9elements/ui-kit/common';
import {RefModelSidebarDaoService} from '@q9elements/ui-kit/refmodels';
import {switchMap, tap} from 'rxjs/operators';
import {AuthService} from '../services/auth.service';

@Injectable()
export class LicenseResolve {
  private router = inject(Router);
  private licenseService = inject(LicenseService);
  private auth = inject(AuthService);
  private refModelService = inject(RefModelSidebarDaoService);

  private checkLicenseAndNavigate(licenseFlag: string, route: ActivatedRouteSnapshot): void {
    const hasLicense = this.licenseService.hasLicenseFlag(licenseFlag);
    if (!hasLicense) {
      this.router.navigate(['license-error'], {
        queryParams: {
          licenseFlag: licenseFlag,
          context: route.url[0]?.path
        }
      });
    }
  }

  resolve(route: ActivatedRouteSnapshot) {
    const refModelId = route.params['refModelId'] as string;
    const requiredLicenseFlag = route.data['requiredLicenseFlag'];

    if (
      requiredLicenseFlag &&
      requiredLicenseFlag !== 'systemModels' &&
      requiredLicenseFlag !== 'orgMetadataDictionary'
    ) {
      return this.auth.fetchUser(refModelId).pipe(
        tap(() => {
          this.checkLicenseAndNavigate(requiredLicenseFlag, route);
        })
      );
    }

    return this.refModelService.getRefModelMeta(refModelId).pipe(
      switchMap((meta: SalesForceData) => {
        const requiredFlag = meta.external ? 'orgMetadataDictionary' : 'systemModels';
        return this.auth.fetchUser(refModelId).pipe(
          tap(() => {
            this.checkLicenseAndNavigate(requiredFlag, route);
          })
        );
      })
    );
  }
}
